import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { formatInTimeZone } from 'date-fns-tz';
import { rates as exchangeRates } from '../../data/exchangeRates';

const JobInfoModal = ({ isOpen, onClose, job, translatorTimezone, selectedCurrency }) => {
  // DÜZELTME 1: Tüm Hook'lar bileşenin en üstüne, koşulsuz olarak taşındı.
  const { t, i18n } = useTranslation();

  const convertedFee = useMemo(() => {
    if (!job) return 0; // job gelene kadar 0 döndür
    const translatorFeeTRY = job.translator_fee ? parseFloat(job.translator_fee) : 0;
    const rate = exchangeRates[selectedCurrency] || 1;
    return translatorFeeTRY / rate;
  }, [job, selectedCurrency]);

  // DÜZELTME 2: Koşullu return (early return) artık Hook'lardan SONRA geliyor.
  if (!isOpen || !job) {
    return null;
  }

  const targetLangsArray = Array.isArray(job.target_langs) ? job.target_langs : [];
  
  const formatDate = (dateString, timezone) => {
    if (!dateString) return '-';
    return formatInTimeZone(new Date(dateString), timezone || 'Europe/Istanbul', 'dd.MM.yyyy HH:mm');
  };

  return ReactDOM.createPortal(
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>{t('assignment_details_title')}</h3>
          <button onClick={onClose} className="close-btn">&times;</button>
        </div>
        <div className="info-modal-body">
          <div className="info-row">
            <span>{t('job_service_type')}</span>
            <strong>{t('service_type_translation')}</strong>
          </div>
          <div className="info-row">
            <span>{t('translation_languages')}</span>
            <strong>{job.source_lang.toUpperCase()} &rarr; {targetLangsArray.join(', ').toUpperCase()}</strong>
          </div>
          <div className="info-row">
            <span>{t('word_count')}</span>
            <strong>{job.word_count}</strong>
          </div>
          <div className="info-row">
            <span>{t('deadline_modal')}</span>
            <strong>{formatDate(job.deadline, translatorTimezone)} ({translatorTimezone})</strong>
          </div>
          <div className="info-row">
            <span>{t('amount')}</span>
            <strong>{convertedFee.toLocaleString(i18n.language, {
                style:'currency', 
                currency: selectedCurrency || 'TRY' 
            })}
            </strong>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default JobInfoModal;